import { IonContent, IonPage } from '@ionic/react'
import type React from 'react'
import type { PropsWithChildren } from 'react'
import { Logo } from '../../components/Logo'

type AuthLayoutProps = PropsWithChildren<{
  id: string
}>

export const AuthLayout: React.FC<AuthLayoutProps> = ({ id, children }) => (
  <IonPage id={id}>
    <IonContent fullscreen className='ion-padding'>
      <div className='auth-layout'>
        <div className='auth-layout__logo'>
          <Logo />
        </div>
        <div className='auth-layout__content'>{children}</div>
      </div>
    </IonContent>
  </IonPage>
)
